<template>
  <div class="modern-loading">
    <div class="loading-container">
      <!-- Spinner principal com gradiente -->
      <div class="spinner-main">
        <div class="spinner-ring"></div>
        <div class="spinner-ring"></div>
        <div class="spinner-ring"></div>
      </div>

      <!-- Texto de carregamento com animação de pontos -->
      <div class="loading-text">
        <span>{{ message }}</span>
        <span class="dots">
          <span class="dot">.</span>
          <span class="dot">.</span>
          <span class="dot">.</span>
        </span>
      </div>

      <div v-if="subtext" class="loading-subtext">{{ subtext }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
  props: {
    message: {
      type: String,
      default: 'Carregando'
    },
    subtext: {
      type: String,
      default: ''
    },
    progress: {
      type: Number,
      default: null
    }
  },
  computed: {
    hasProgress() {
      return typeof this.progress === 'number'
    }
  }
}
</script>

<style scoped>
.modern-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  padding: 40px 20px;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

/* Spinner principal com múltiplos anéis */
.spinner-main {
  position: relative;
  width: 60px;
  height: 60px;
}

.spinner-ring {
  position: absolute;
  border: 3px solid transparent;
  border-radius: 50%;
  animation: spin 2s linear infinite;
}

.spinner-ring:nth-child(1) {
  width: 60px;
  height: 60px;
  border-top-color: #007bff;
  animation-duration: 1.5s;
}

.spinner-ring:nth-child(2) {
  width: 45px;
  height: 45px;
  border-top-color: #28a745;
  animation-duration: 2s;
  top: 7.5px;
  left: 7.5px;
}

.spinner-ring:nth-child(3) {
  width: 30px;
  height: 30px;
  border-top-color: #ffc107;
  animation-duration: 2.5s;
  top: 15px;
  left: 15px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Texto de carregamento */
.loading-text {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  color: #495057;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.loading-subtext {
  margin-top: -8px;
  font-size: 12px;
  color: #6c757d;
  text-align: center;
}

.dots {
  display: inline-flex;
  margin-left: 4px;
}

.dot {
  opacity: 0;
  animation: dotFade 1.4s infinite;
  margin-left: 2px;
}

.dot:nth-child(1) {
  animation-delay: 0s;
}
.dot:nth-child(2) {
  animation-delay: 0.2s;
}
.dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes dotFade {
  0%,
  80%,
  100% {
    opacity: 0;
  }
  40% {
    opacity: 1;
  }
}

/* Barra de progresso sutil */
.progress-bar {
  width: 120px;
  height: 3px;
  background-color: #e9ecef;
  border-radius: 2px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #007bff, #28a745, #ffc107);
  border-radius: 2px;
  animation: progressMove 2s ease-in-out infinite;
}

@keyframes progressMove {
  0% {
    width: 0%;
    transform: translateX(-100%);
  }
  50% {
    width: 100%;
    transform: translateX(0%);
  }
  100% {
    width: 0%;
    transform: translateX(100%);
  }
}

/* Responsividade */
@media (max-width: 768px) {
  .modern-loading {
    min-height: 150px;
    padding: 30px 15px;
  }

  .spinner-main {
    width: 50px;
    height: 50px;
  }

  .spinner-ring:nth-child(1) {
    width: 50px;
    height: 50px;
  }

  .spinner-ring:nth-child(2) {
    width: 37.5px;
    height: 37.5px;
    top: 6.25px;
    left: 6.25px;
  }

  .spinner-ring:nth-child(3) {
    width: 25px;
    height: 25px;
    top: 12.5px;
    left: 12.5px;
  }

  .loading-text {
    font-size: 14px;
  }

  .progress-bar {
    width: 100px;
  }
}

/* Tema escuro */
@media (prefers-color-scheme: dark) {
  .loading-text {
    color: #e9ecef;
  }

  .progress-bar {
    background-color: #495057;
  }
}
</style>
